import BaseClass from "../../util/BaseClass";
import Context from "../../context/Context";
import VersionManager from "./VersionManager";
import * as aiimUtil from "../../aiim/util/aiimUtil";
import * as serviceUtil from "./serviceUtil";
import * as sourceUtil from "./sourceUtil";

export default class Project extends BaseClass {

  isHosted;
  isVersioned;
  requiresVersioning;

  issues;

  hostedInfo;
  versionedInfo;

  hasIssues() {
    return this.issues && this.issues.length > 0;
  }

  interrogateMap(map) {
    const promise = new Promise((resolve,reject) => {
      const i18n = Context.instance.i18n;
      const aiim = Context.instance.aiim;
      const datasets = aiim && aiim.datasets;
      this.issues = [];
      this.requiresVersioning = Context.instance.getPortal().isPortal;

      // TODO ensure that the user is a publisher

      if (!map) {
        const view = Context.instance.views.mapView;
        map = view && view.map;
      }
      const layers = (map && map.layers) || [];

      const result = {
        isVersioned: false,
        baseline: {
          peopleLayer: null,
          peopleSource: null,
          unitsLayer: null,
          unitsSource: null
        },
        versioned: {
          peopleLayer: null,
          unitsLayer: null,
          areasTableInfo: null,
          featureServiceUrl: null,
          versionManagerUrl: null
        },
        nonVersioned: {
          peopleLayer: null,
          unitsLayer: null,
          featureServiceUrl: null
        }
      }

      Promise.resolve().then(() => {
        return aiimUtil.waitForLayers(null,layers);
      }).then(() => {

        if (!datasets || !datasets.levels) {
          this.issues.push({
            key: "noLevels",
            message: i18n.configurator.issues.noLevels
          });
        }
        if (!datasets || !datasets.facilities) {
          this.issues.push({
            key: "noFacilities",
            message: i18n.configurator.issues.noFacilities
          });
        }

        const baseline = result.baseline;
        const nonVersioned = result.nonVersioned;
        const versioned = result.versioned;
        baseline.peopleSource = sourceUtil.getInitialPeopleSource();
        baseline.peopleLayer = baseline.peopleSource && baseline.peopleSource.layer2D;
        baseline.unitsSource = sourceUtil.getInitialUnitsSource();
        baseline.unitsLayer = baseline.unitsSource && baseline.unitsSource.layer2D;

        layers.forEach(layer => {
          let hasPeopleFields = sourceUtil.hasPeopleFields(layer,true);
          let hasUnitFields = sourceUtil.hasUnitsFields(layer,true);
          if (hasPeopleFields) {
            if (layer.capabilities && layer.capabilities.data && layer.capabilities.data.isVersioned) {
              result.isVersioned = true;
              versioned.peopleLayer = layer;
            } else {
              nonVersioned.peopleLayer = layer;
            }
          } else if (hasUnitFields) {
            if (layer.capabilities && layer.capabilities.data && layer.capabilities.data.isVersioned) {
              result.isVersioned = true;
              versioned.unitsLayer = layer;
            } else {
              nonVersioned.unitsLayer = layer;
            }
          }
        });

        if (result.isVersioned) {
          if (versioned.peopleLayer && versioned.unitsLayer) {
            const fsUrl = versioned.peopleLayer.url;
            const vmUrl = fsUrl.replace("/FeatureServer","/VersionManagementServer");
            versioned.featureServiceUrl = fsUrl;
            versioned.versionManagerUrl = vmUrl;
            if (baseline.peopleLayer && baseline.peopleLayer !== versioned.peopleLayer) {
              baseline.peopleLayer.visible = false;
            }
            if (baseline.unitsLayer && baseline.unitsLayer !== versioned.unitsLayer) {
              baseline.unitsLayer.visible = false;
            }
            if (versioned.peopleLayer.url !== versioned.unitsLayer.url) {
              // not in same service
              this.issues.push({
                key: "requiresVersionedDataset",
                message: i18n.spaceplanner.issues.missingLayers,
                //message: i18n.spaceplanner.issues.requiresVersionedDataset
              });
            }
          } else {
            this.issues.push({
              key: "requiresVersionedDataset",
              message: i18n.spaceplanner.issues.missingLayers
              //message: i18n.spaceplanner.issues.requiresVersionedDataset
            });
          }
        } else if (this.requiresVersioning){
          this.issues.push({
            key: "requiresVersionedDataset",
            message: i18n.spaceplanner.issues.missingLayers
            //message: i18n.spaceplanner.issues.requiresVersionedDataset
          });

        } else {
          // non versioned
          if (nonVersioned.peopleLayer && nonVersioned.unitsLayer) {
            const fsUrl = nonVersioned.peopleLayer.url;
            nonVersioned.featureServiceUrl = fsUrl;
            // if (baseline.peopleLayer && baseline.peopleLayer !== nonVersioned.peopleLayer) {
            //   baseline.peopleLayer.visible = false;
            // }
            // if (baseline.unitsLayer && baseline.unitsLayer !== nonVersioned.unitsLayer) {
            //   baseline.unitsLayer.visible = false;
            // }
            if (nonVersioned.peopleLayer.url !== nonVersioned.unitsLayer.url) {
              // not in same service
              this.issues.push({
                key: "requiresDataset",
                message: i18n.spaceplanner.issues.missingLayers
                //message: i18n.spaceplanner.issues.requiresDataset
              });
            }
          } else {
            this.issues.push({
              key: "requiresDataset",
              message: i18n.spaceplanner.issues.missingLayers
              //message: i18n.spaceplanner.issues.requiresDataset
            });
          }
        }

      }).then(() => {
        if (!this.hasIssues()) {
          if (result.isVersioned) {
            return this._loadVersioned(result);
          } else {
            return this._loadHosted(result);
          }
        }
      }).then(() => {
        console.log("interrogateMap.result",result)
        resolve(result);
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

  _loadHosted(task) {
    const promise = new Promise((resolve,reject) => {
      const i18n = Context.instance.i18n;
      const {nonVersioned} = task;
      const {featureServiceUrl} = nonVersioned;
      const sourceInfo = {
        serviceUrl: featureServiceUrl
      };
      Promise.resolve().then(() => {
        return serviceUtil.readServiceJson(featureServiceUrl,sourceInfo);
      }).then(() => {
        if (!sourceInfo.peopleLayerInfo || !sourceInfo.unitsLayerInfo ||
            !sourceInfo.areasTableInfo) {
          this.issues.push({
            key: "requiresDataset",
            message: i18n.spaceplanner.issues.missingLayers
            //message: i18n.spaceplanner.issues.requiresDataset
          });
        }
        // if (!sourceUtil.hasAreasFields(sourceInfo.areasTableInfo)) {
        //   this.issues.push({
        //     key: "requiresDataset",
        //     message: i18n.spaceplanner.issues.requiresDataset
        //   });
        // }
      }).then(() => {
        const cap = sourceInfo.serviceInfo.capabilities.split(",");
        if (cap.indexOf("Extract") === -1) {
          this.issues.push({
            key: "exportNotEnabled",
            message: i18n.spaceplanner.issues.exportNotEnabled
          });
        }
      }).then(() => {
        sourceInfo.serviceItem = (nonVersioned.peopleLayer && nonVersioned.peopleLayer.portalItem);
        this.isHosted = true;
        this.hostedInfo = {
          peopleLayer: nonVersioned.peopleLayer,
          unitsLayer: nonVersioned.unitsLayer,
          sourceInfo: sourceInfo
        }
      }).then(() => {
        resolve();
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

  _loadVersioned(task) {
    const promise = new Promise((resolve,reject) => {
      const i18n = Context.instance.i18n;
      const {versioned} = task;
      const {featureServiceUrl} = versioned;
      const versionManager = new VersionManager();
      const sourceInfo = {
        serviceUrl: featureServiceUrl
      };
      Promise.resolve().then(() => {
        return serviceUtil.readServiceJson(featureServiceUrl,sourceInfo);
      }).then(() => {
        if (!sourceUtil.hasAreasFields(sourceInfo.areasTableInfo)) {
          this.issues.push({
            key: "requiresVersionedDataset",
            message: i18n.spaceplanner.issues.missingLayers
            //message: i18n.spaceplanner.issues.requiresVersionedDataset
          });
        }
      }).then(() => {
        const cap = sourceInfo.serviceInfo.capabilities.split(",");
        if (cap.indexOf("Editing") === -1) {
          this.issues.push({
            key: "editingNotEnabled",
            message: i18n.spaceplanner.issues.editingNotEnabled
          });
        }
      }).then(() => {
        if (!this.hasIssues()) {
          return versionManager.load(versioned.versionManagerUrl);
        }
      }).then(() => {
        sourceInfo.serviceItem = (versioned.peopleLayer && versioned.peopleLayer.portalItem);
        this.isVersioned = true;
        this.versionedInfo = {
          peopleLayer: versioned.peopleLayer,
          unitsLayer: versioned.unitsLayer,
          versionManager: versionManager,
          sourceInfo: sourceInfo
        }
      }).then(() => {
        resolve();
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

}
